import React from "react";
import { NavLink } from "react-router-dom";
import "./Top10.css";

function Top10({ top10 }) {
  return (
    <ul className="crypto-list">
      {top10.map((item) => {
        return (
            <NavLink to={item.id} className="cryptoMain">
          <li className="list collection center container " key={item.id}>
            <section className="cryptoMain">#{item.rank}</section>
              {item.name}
            <p className="cryptoMain">${item.price_usd} USD</p>
          </li>
            </NavLink>
        );
      })}
    </ul>
  );
}

export default Top10;
